import type { ReactNode } from "react";
import { SubTabs } from "@/components/layout/SubTabs";

const TABS = [
  { href: "/settings/data-feed", label: "Data Feed" },
  { href: "/settings/indices", label: "Universe" },
  { href: "/settings/breadth", label: "Breadth" },
  { href: "/settings/pages", label: "Pages" },
  { href: "/settings/indicators", label: "Indicators" },
  { href: "/settings/theme", label: "Theme" },
  { href: "/settings/backup", label: "Backup" },
  { href: "/settings/maintenance", label: "Maintenance" },
];

export default function SettingsLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      <SubTabs tabs={TABS} />
      {children}
    </main>
  );
}
